import axios from 'axios';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
// import router from '../router';
import store from '../store';

/* eslint no-underscore-dangle: 0 */
// const api = axios.create({
//   baseURL: 'https://soonforwardclient1-backend.azurewebsites.net/',
// });

// api.interceptors.request.use((request) => {
//   const newRequest = request;
//   console.log('Starting Request', request);
//   // const token = localStorage.getItem('access');
//   // if (token) {
//   //   newRequest.headers.Authorization = `Bearer: ${token}`;
//   // }
//   // firebase.auth().onAuthStateChanged((user) => {
//   //   if (user) {
//   //     user.getIdToken(true).then((idToken) => {
//   //       newRequest.headers.Authorization = `Bearer: ${idToken}`;
//   //     });
//   //   }
//   // });
//   return newRequest;
// });

const api = (() => {
  const getAuthToken = async () => {
    let token = null;
    try {
      token = `Bearer: ${await firebase.auth().currentUser.getIdToken(true)}`;
    } catch (err) {
      console.log('getAuthToken', err);
    }
    return token;
  };

  const instance = axios.create({
    baseURL: 'https://gunter-backend.soonforward.us/',
  });

  instance.interceptors.request.use(async (config) => {
    console.log('Starting Request', config);
    const newconfig = config;
    newconfig.headers.Authorization = await getAuthToken();
    return newconfig;
  });

  return instance;
})();

// api.interceptors.response.use((response) => {
//   console.log('Response:', response);
//   return response;
// }, async (error) => {
//   const originalRequest = error.config;
//   if (error.response.status === 401 && originalRequest.url.includes('/refreshtoken')) {
//     store.commit('deAuthenticate');
//     router.push('/');
//     return Promise.reject(error);
//   }
//   if (error.response.status === 401 && !originalRequest._retry) {
//     originalRequest._retry = true;
//     try {
//       await api.post('/refreshtoken', {
//         data: {
//           refreshToken: localStorage.getItem('refresh'),
//         },
//       }).then((response) => {
//         if (response.status === 200) {
//           localStorage.access = response.data.result;
//         }
//       });
//     } catch (err) {
//       console.log(err);
//     }
//     return api(originalRequest);
//   }
//   return Promise.reject(error);
// });

api.interceptors.response.use((response) => {
  console.log('Response:', response);
  return response;
}, async (error) => {
  if (error.response.status === 401) {
    store.commit('deAuthenticate');
    this.$router.push('/');
    return Promise.reject(error);
  }
  return Promise.reject(error);
});

export default api;
